import { render, staticRenderFns } from "./select-activity.vue?vue&type=template&id=20c0409c"
import script from "./select-activity.vue?vue&type=script&lang=ts"
export * from "./select-activity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports